import Marquee from "react-fast-marquee"
import { TTextSlider } from "../../../types/index"

type TextSliderProps = Pick<TTextSlider, "textFields">

export default function TextSlider({ textFields }: TextSliderProps) {
    if (!textFields || textFields.length === 0) return null

    return (
        <div className="w-full py-6  border-y border-base-300/30">
            <Marquee
                autoFill
                speed={50}
                
                className="overflow-hidden"
            >
                {textFields.map((field, idx) => (
                    <div key={idx} className="flex items-center gap-8 px-8">
                        <span className="text-lg font-semibold tracking-wider text-base-content/50 uppercase whitespace-nowrap">
                            {field.text}
                        </span>
                        {idx < textFields.length - 1 && (
                            <span className="text-base-content/50 text-2xl leading-3 mb-1">•</span>
                        )}
                    </div>
                ))}
            </Marquee>
        </div>
    )
}
